// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2W2SJ","title":"Info_title__JjGRK","links":"Info_links__tip6W","link":"Info_link__33gjB","logo":"Info_logo__1ryEa"};